// Auto-generated from design-tokens/colors.json — do not edit manually.
// Source: Figma Elements New (dev-metadata-sync branch)

export const mainLight = {
  CONTENT_PRIMARY: '#02151E',
  CONTENT_SECONDARY: '#505D63',
  DISABLE_CONTENT: '#B1BBBF',
  HOVER: '#E7F0F3',
  BACKGROUND_PRIMARY: '#FFFFFF',
  BACKGROUND_SECONDARY: '#F2F4F5',
  DISABLE_BACKGROUND: '#E5E9EB',
  SECTIONS_BACKGROUNDS: '#E5E9EB',
  DIVIDER: '#CFD9DC',
  TOOLTIPS: 'rgba(2, 21, 30, 0.9)',
  HINTS: '#02151E',
} as const;

export const mainDark = {
  CONTENT_PRIMARY: '#FFFFFF',
  CONTENT_SECONDARY: '#B1BBBF',
  DISABLE_CONTENT: '#595959',
  HOVER: '#768084',
  BACKGROUND_PRIMARY: '#2B2D30',
  BACKGROUND_SECONDARY: '#1E1F22',
  DISABLE_BACKGROUND: '#3F3F3F',
  SECTIONS_BACKGROUNDS: '#3F3F3F',
  DIVIDER: '#404244',
  TOOLTIPS: 'rgba(2, 21, 30, 0.9)',
  HINTS: '#FFFFFF',
} as const;

export const red = {
  RED_01: '#F04465',
  RED_02: '#EF5683',
  RED_03: '#F17297',
  RED_04: '#F48EAC',
  RED_05: '#F7ABC1',
  RED_06: '#FAC7D6',
  RED_07: '#FCE3EA',
  RED_OPACITY: 'rgba(240, 68, 101, 0.2)',
} as const;

export const orange = {
  ORANGE_01: '#FE5C00',
  ORANGE_02: '#FE7324',
  ORANGE_03: '#FE8B49',
  ORANGE_04: '#FEA26D',
  ORANGE_05: '#FFB992',
  ORANGE_06: '#FFD0B6',
  ORANGE_07: '#FFE8DB',
  ORANGE_OPACITY_02: 'rgba(254, 92, 0, 0.2)',
  ORANGE_OPACITY_01: 'rgba(254, 92, 0, 0.1)',
} as const;

export const yellow = {
  YELLOW_01: '#FFC647',
  YELLOW_02: '#FFCE61',
  YELLOW_03: '#FFD67C',
  YELLOW_04: '#FFDE96',
  YELLOW_05: '#FFE7B0',
  YELLOW_06: '#FFEFCA',
  YELLOW_07: '#FFF7E5',
  YELLOW_OPACITY: 'rgba(255, 198, 71, 0.2)',
} as const;

export const blue = {
  BLUE_01: '#008EDD',
  BLUE_02: '#4F9ADE',
  BLUE_03: '#5FA8E2',
  BLUE_04: '#73B6E8',
  BLUE_05: '#88C5EC',
  BLUE_06: '#B9E1F6',
  BLUE_07: '#CAF1FD',
  BLUE_OPACITY: 'rgba(0, 142, 221, 0.2)',
} as const;

export const grey = {
  GREY_01: '#B1BBBF',
  GREY_02: '#CFD9DC',
  GREY_03: '#CFD9DC',
  GREY_04: '#DEE4E6',
  GREY_05: '#E5E9EB',
  GREY_06: '#EBEFF0',
  GREY_07: '#F2F4F5',
  GREY_OPACITY: 'rgba(177, 187, 191, 0.2)',
} as const;

export const green = {
  GREEN_01: '#29A072',
  GREEN_02: '#48AE86',
  GREEN_03: '#66BB9A',
  GREEN_04: '#A1FFD8',
  GREEN_05: '#B0FFDF',
  GREEN_06: '#C0FFE5',
  GREEN_07: '#D0FFEC',
} as const;

export const VaultColors = {
  PINK: '#FEB2F1',
  LIGHT_BLUE: '#8AE3FF',
  PURPLE: '#BDBEF7',
  PEACH: '#E3B2A1',
  BROWN: '#D1B9C0',
  GREEN: '#A1FFD8',
} as const;
